import Axios from "axios";
import Cookies from "js-cookie";
import { API_ROOT } from "../config";

var instance = Axios.create({
  baseURL: API_ROOT,
  timeout: 60000
});
console.log(API_ROOT);

export default {
  state: {
    school_id: null,
    schooltype_id: null
  },
  mutations: {
    setSchool(state, school_id) {
      console.log("School");
      Cookies.set("school_id", school_id);
      state.school_id = school_id;
    },
    setSchoolType(state, schooltype_id) {
      console.log("School Type");
      Cookies.set("schooltype_id", schooltype_id);
      state.schooltype_id = schooltype_id;
    }
  },
  getters: {
    getSchool(state) {
      return state.school_id;
    },
    getSchoolType(state) {
      return state.schooltype_id;
    }
  },
  actions: {
    setSchool(context, obj) {
      context.commit("setSchool", obj);
    },
    setSchoolType(context, obj) {
      context.commit("setSchoolType", obj);
    }
  }
};
